module.exports = __webpack_public_path__ + "static/media/about_01.3a795425.svg";